/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Generalsettings1Inputs */

const en_entity_generalsettings1 = /** @type {(inputs: Entity_Generalsettings1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`General Settings`)
};

const de_entity_generalsettings1 = /** @type {(inputs: Entity_Generalsettings1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allgemeine Einstellungen`)
};

/**
* | output |
* | --- |
* | "General Settings" |
*
* @param {Entity_Generalsettings1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_generalsettings1 = /** @type {((inputs?: Entity_Generalsettings1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Generalsettings1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_generalsettings1(inputs)
	return de_entity_generalsettings1(inputs)
});
export { entity_generalsettings1 as "entity_generalSettings" }